<template>

    <trax-ui-ajax-form-in-modal :id="id" :toastr-id="toastrId" :endpoint="endpoint" 
        :props="props" :titles="titles" :bus="bus" :form="form" icons="1">

        <trax-ui-input type="text" icon="text_fields" :placeholder="lang.polaris.form.name"
            v-model="form.name" :error="errors.name" required="1">
        </trax-ui-input>

        <trax-ui-input type="text" icon="text_fields" rows="3" :placeholder="lang.polaris.form.description"
            v-model="form.description" :error="errors.description">
        </trax-ui-input>

        <trax-ui-select icon="playlist_add_check" :placeholder="lang.polaris.training.competency_domains"
            :options="competency_domain_lists_select"
            v-model="form.domain_list_id"
            :error="errors.domain_list_id"
        ></trax-ui-select>

        <trax-ui-select icon="cached" v-model="form.status" :options="status_select">
        </trax-ui-select>

    </trax-ui-ajax-form-in-modal>
    
</template>

<script>
    export default {

        props: ['bus', 'id', 'toastrId', 'endpoint', 'typeCode'],
    
        data: function() {
            return {
                lang: lang,
                form: {},
                errors: {},
                competency_domain_lists_select: data.competency_domain_lists_select,
                status_select: data.status_select,
                props: {
                    id: { source:'id' },
                    name: { source:'name' },
                    description: { source:'description' },
                    domain_list_id: { source:'domain_list_id' },
                    status: { source:'status', default:'draft' },
                    type: { source:'type', default: this.typeCode }
                },
                titles: {
                    new: lang.polaris.training.new_index,
                    duplicate: lang.polaris.training.index_duplicate,
                    update: lang.polaris.training.index_update
                }
            }
        },

        created: function() {
            var that = this;

            this.bus.$on(that.id+'-errors', function(errors) {
                that.errors = errors;
            });

            this.bus.$on(that.id+'-data', function(data) {
                that.form = data;
            });

            this.bus.$on(that.id+'-data-duplicate', function(data) {
                that.form = data;
                that.form.name += ' (' + lang.polaris.training.copy + ')';
                that.form.status = 'draft';
            });
        }

    }
</script>
